import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useOrbitLOnboardingDetailQuery } from "Api/Queries/Merchants/useOrbitLOnboardingDetailQuery";
import { Resources, useResource } from "Translations/Resources";
import { OrbitLOnboardingDetailContent } from "Components/Merchants/OrbitLOnboarding/OrbitLOnboardingDetailContent";

const RESOURCES = Resources.Pages.Content.Merchants.OrbitLOnboarding.Detail;

type Props = {
  merchantPublicID: string;
  isOpen: boolean;
  onClose: () => void;
  isEditingEnabled: boolean;
};

export const OrbitLOnboardingDetailModal = ({
  merchantPublicID,
  isOpen,
  onClose,
  isEditingEnabled,
}: Props) => {
  const { data, isLoading } = useOrbitLOnboardingDetailQuery(merchantPublicID);
  const { t } = useResource();

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{t(RESOURCES.Title)}</DialogTitle>
      <DialogContent dividers>
        {isLoading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : (
          data && (
            <OrbitLOnboardingDetailContent
              detail={data}
              merchantPublicID={merchantPublicID}
              isEditingEnabled={isEditingEnabled}
            />
          )
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t(RESOURCES.CloseButton)}</Button>
      </DialogActions>
    </Dialog>
  );
};
